import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MateriaService } from '../../../services/materia.service';

@Component({
  selector: 'list-materia-datas',
  templateUrl: './list-materia-datas.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ListMateriaDatasComponent implements OnInit {

  @Input() temaId: number;
  datas: any

  constructor(private materiaService: MateriaService) { }

  ngOnInit() {
      this.getDatas(this.temaId);
  }

  getDatas(idTema: number) {
    this.materiaService.getMateriasData(idTema).subscribe((res) => {
      this.datas = res;
    });
  }

  toString(mes: number){
    switch(mes){
      case 1: return "Janeiro";
      case 2: return "Fevereiro";
      case 3: return "Março";
      case 4: return "Abril";
      case 5: return "Maio";
      case 6: return "Junho";
      case 7: return "Julho";
      case 8: return "Agosto";
      case 9: return "Setembro";
      case 10: return "Outubro";
      case 11: return "Novembro";
      case 12: return "Dezembro";
      default: return "";
    }
  }

}
